import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { customUseEffect } from "@common";
import { setAssessmentSearchTerm } from "@features";
const useAssessmentKanbanController = ({
  showAdd,
  setShowAdd,
  showViewDetails,
  setShowViewDetails,
  viewMode,
  setViewMode,
  displayRows = [],
  visibleStatusItems = [],
  statusItems = [],
  rowsByStatus = {},
  effectiveVisibleStatuses = [],
  visibleStatuses = [],
  setVisibleStatuses,
  renderView,
  showArchive,
  handleArchive,
  handleUnArchive
}) => {
  const [columnAnchorEl, setColumnAnchorEl] = useState(null);
  const skillAssessment = useSelector((state) => state.skillAssessment);
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState(skillAssessment?.searchAssessmentData);

  // Sync when Redux state changes externally
  customUseEffect(() => {
    setSearchTerm(skillAssessment?.searchAssessmentData || "");
  }, [skillAssessment?.searchAssessmentData]);

  return {
    heading: showArchive ? "Archived Assessments" : "Assessments",
    compact: showViewDetails,
    newBtn: {
      showAdd,
      setShowAdd,
    },
    search: {
      searchTerm,
      handleSearch: (value) => {
        setSearchTerm(value);
        dispatch(setAssessmentSearchTerm(value));
      },
      handleSearchClear: () => {
        setSearchTerm("");
        dispatch(setAssessmentSearchTerm(""));
      },
      placeholder: "Search Assessments...",
    },
    view: {
      viewMode,
      setViewMode,
      data: displayRows,
    },
    column: {
      title: "Choose Assessment Statuses",
      columnAnchorEl,
      setColumnAnchorEl,
      visibleStatusItems,
      statusItems,
      heading: "Show Assessment Statuses",
      rowsByStatus,
      effectiveVisibleStatuses,
      visibleStatuses,
      setVisibleStatuses,
    },
    archive: {
      showArchive,
      archiveTooltip: "View All Assessments",
      unarchiveTooltip: "Archived Assessments",
      handleArchive: handleArchive,
      handleUnArchive: handleUnArchive
    },
    kanbanView: {
      renderFeatureView: renderView,
    },
  };
};

export default useAssessmentKanbanController;